import HeaderSection from '@/components/Header/HeaderSection.vue';
import { get_user_profile, get_token, set_user_profile } from '@/router';
import UserEditForm from '@/components/UserEditForm/UserEditForm.vue';

export default {
    name: "EditProfile",

    components: {
        HeaderSection,
        UserEditForm
    },

    data() {
        return ({
            breadcrumb: [
                { id: "home", title: "Dashboard" },
                { id: "profile", title: "Profile" },
                { id: "edit", title: "Edit Profile" }
            ],

            form: {
                first_name: "first name",
                last_name: "last name",
                email: "user@example.org",
                phone: "",
                email_readonly: true,
                location: "Gauteng, South Africa",
                bio: ""
            },
            error_message: ""
        });
    },
    mounted(){
        if (this.is_editing_managed_user()) {
            this.breadcrumb = [
                { id: "home", title: "Dashboard" },
                { id: "user_management", title: "User Management" },
                { id: "edit", title: "Edit User" }
            ];
        }
        this.loadUserProfile();
    },
    computed:{
        avatar_initials() {
            const profile = this.get_edit_target_profile();
            if (!profile) return 'UR';
            const first = profile.first_name?.charAt(0) || '';
            const last = profile.last_name?.charAt(0) || '';
            return (first + last).toUpperCase() || 'UR';
        }
    },
    methods: {
        is_editing_managed_user() {
            return Boolean(this.$route?.query?.user_id);
        },

        get_edit_target_profile() {
            if (this.is_editing_managed_user()) {
                const stored_profile = sessionStorage.getItem("edit_user_profile");
                if (stored_profile) {
                    try { return JSON.parse(stored_profile); } catch { return {}; }
                }
            }

            return get_user_profile() || {};
        },

        set_profile_edit(profile){
            const first_name = profile.first_name;
            const last_name = profile.last_name;
            const email = profile.email
            const phone_number = profile.phone_number

            this.form.first_name = `${first_name}`.trim() || "Guest User";
            this.form.email = `${email}`.trim();
            this.form.last_name = `${last_name}`.trim() || "Guest User";
            this.form.phone = phone_number;
        },
        //Getting User Informations/Profile
        async loadUserProfile(){
            const profile = this.get_edit_target_profile();
            
            // Fetch phone_number from backend UserProfile API
            const update_profile_url = process.env.VUE_APP_UPDATE_USER_URL;
            const raw_user_id = profile && (profile.id || profile.user_id);
            const user_id = Number.parseInt(raw_user_id, 10);
            const auth_token = get_token();
            
            if (Number.isInteger(user_id) && auth_token && update_profile_url) {
                try {
                    const base_url = update_profile_url.endsWith("/")
                        ? update_profile_url
                        : `${update_profile_url}/`;
                    const profile_url = `${base_url}${user_id}/`;

                    const response = await fetch(profile_url, {
                        method: "GET",
                        headers: {
                            Authorization: `Token ${auth_token}`,
                            "Content-Type": "application/json",
                        },
                    });

                    if (response.status === 200) {
                        const profile_data = await response.json();
                        profile.phone_number = profile_data.phone_number;
                    }
                } catch (error) {
                    console.warn("Unable to load user profile phone number.", error);
                }
            }
            
            this.set_profile_edit(profile);
        },
    // Called when breadcrumb item is clicked
    handleBreadcrumbClick(id) {
        if (id === "home") {
            this.$router.push("/home");
        }
        if (id === "profile") {
            this.$router.push("/profile");
        }
    },

    cancelEdit() {
        this.$router.push("/profile");
    },
    async update_user(){
        //Update user details API - handles both User and UserProfile models
        const update_profile_url = process.env.VUE_APP_UPDATE_USER_URL;
        const update_user_url = process.env.VUE_APP_VIEW_USER_URL;
        
        const profile = this.get_edit_target_profile();
        const raw_user_id = profile && (profile.id || profile.user_id);
        const user_id = Number.parseInt(raw_user_id, 10);

        const auth_token = get_token();
        if (!Number.isInteger(user_id) || !auth_token || !update_profile_url || !update_user_url) {
            this.error_message = "Profile update is not configured correctly.";
            return false;
        }

        const first_name = this.form.first_name;
        const last_name = this.form.last_name;
        const phone_number = this.form.phone;
        
        // Build URLs for both endpoints
        const base_profile_url = update_profile_url.endsWith("/")
            ? update_profile_url
            : `${update_profile_url}/`;
        const profile_update_url = `${base_profile_url}${user_id}/update/`;
        
        const base_user_url = update_user_url.endsWith("/")
            ? update_user_url
            : `${update_user_url}/`;
        const user_update_url = `${base_user_url}${user_id}/update/`;
    
        this.error_message = "";

        try{
            // Update User model (first_name, last_name)
            const user_payload = {
                method: "POST",
                headers: {
                    'Authorization': `Token ${auth_token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "first_name": first_name,
                    "last_name": last_name
                })
            };
            
            const user_response = await fetch(user_update_url, user_payload);
            
            // Update UserProfile model (phone_number)
            const profile_payload = {
                method: "POST",
                headers: {
                    'Authorization': `Token ${auth_token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "phone_number": phone_number
                })
            };
            
            const profile_response = await fetch(profile_update_url, profile_payload);

            // Update session variables if both requests succeed
            if(user_response.status === 200 && profile_response.status === 200){
                // Update profile details in session
                profile.first_name = first_name;
                profile.last_name = last_name;
                profile.phone_number = phone_number;
                
                set_user_profile(profile);
                return true;
            }
            this.error_message = "Failed to update user or profile.";
            return false;
        }catch(error){
            this.error_message = error.message || "Failed to update profile.";
            return false;
        }
    },
    async saveProfile() {
        const update_succeeded = await this.update_user();
        if (update_succeeded) {
            sessionStorage.removeItem("edit_user_profile");
            this.$router.push(this.is_editing_managed_user() ? "/user_management" : "/profile");
        }
    }
    }
};
